export const showConfiguration = (state) => state.config
